<template>
  <b-container>
    <b-row v-if="isManagementMode">
      <b-col>
        <b-dropdown
          v-if="v2"
          id="dropdown-1"
          text="Available Pages"
          block
          class="m-md-2"
        >
          <b-dropdown-item
            v-for="(aPage, i) in filteredPages"
            :key="`ddp_${i}`"
          >
            https://d3rriana.com/corner/the-little-ant-that-did/pages/{{
              aPage.pageName
            }}
          </b-dropdown-item>
        </b-dropdown>
        <b-form-select
          v-model="selectedPageContent"
          :options="filteredPages"
          text-field="pageName"
          value-field="content"
          size="sm"
          class="mt-3"
          style="border-radius: 5px;"
        />
      </b-col>
    </b-row>
    <br /><br />
    <tip-tap-output v-if="selectedPageContent" :content="selectedPageContent" />
  </b-container>
</template>

<script>
import TipTapOutput from "@/components/common/tipTapOutput";
import { mapGetters } from "vuex";
export default {
  name: "DisplayPages",
  components: {
    TipTapOutput
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      v2: false,
      selectedPageContent: null
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    settings() {
      return this.resource && this.resource.data && this.resource.data.settings
        ? this.resource.data.settings
        : null;
    },
    pages() {
      return this.settings && Array.isArray(this.settings.pages)
        ? this.settings.pages
        : [];
    },
    filteredPages() {
      return this.pages && Array.isArray(this.pages)
        ? this.pages.filter(aPage => {
            return !aPage.hasOwnProperty("_deleted_at");
          })
        : [];
    }
  },
  methods: {
    handleChange(changeMade) {
      //console.log(changeMade);
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
